function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 86.3392,
  cy: 88.0003,
  r: 83.0189,
  stroke: "#AF6AF4",
  strokeOpacity: 0.05,
  strokeWidth: 6.64151
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7148 45.7858L93.8396 102.395H80.0096L78.0172 45.7858H95.7148ZM87.2762 129.82C84.3071 129.82 81.8458 128.922 79.8924 127.125C78.0172 125.25 77.0795 122.945 77.0795 120.21C77.0795 117.475 78.0172 115.209 79.8924 113.412C81.8458 111.537 84.3071 110.599 87.2762 110.599C90.1672 110.599 92.5504 111.537 94.4256 113.412C96.3009 115.209 97.2385 117.475 97.2385 120.21C97.2385 122.945 96.3009 125.25 94.4256 127.125C92.5504 128.922 90.1672 129.82 87.2762 129.82Z",
  fill: "#AF6AF4",
  fillOpacity: 0.05
});
function SvgDiscardChangesBgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 176,
    viewBox: "0 0 173 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardChangesBgIcon);
export default __webpack_public_path__ + "static/media/discardChangesBgIcon.f3654c99.svg";
export { ForwardRef as ReactComponent };